var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5554 13.7061H3.79004C3.23804 13.7061 2.79004 13.2581 2.79004 12.7061C2.79004 12.1541 3.23804 11.7061 3.79004 11.7061H27.5554C28.1074 11.7061 28.5554 12.1541 28.5554 12.7061C28.5554 13.2581 28.1074 13.7061 27.5554 13.7061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6016 18.9131C21.0496 18.9131 20.5963 18.4651 20.5963 17.9131C20.5963 17.3611 21.0376 16.9131 21.5896 16.9131H21.6016C22.1536 16.9131 22.6016 17.3611 22.6016 17.9131C22.6016 18.4651 22.1536 18.9131 21.6016 18.9131Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.685 18.9131C15.133 18.9131 14.6796 18.4651 14.6796 17.9131C14.6796 17.3611 15.121 16.9131 15.673 16.9131H15.685C16.237 16.9131 16.685 17.3611 16.685 17.9131C16.685 18.4651 16.237 18.9131 15.685 18.9131Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75587 18.9131C9.20387 18.9131 8.74921 18.4651 8.74921 17.9131C8.74921 17.3611 9.19187 16.9131 9.74387 16.9131H9.75587C10.3079 16.9131 10.7559 17.3611 10.7559 17.9131C10.7559 18.4651 10.3079 18.9131 9.75587 18.9131Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6016 24.0952C21.0496 24.0952 20.5963 23.6472 20.5963 23.0952C20.5963 22.5432 21.0376 22.0952 21.5896 22.0952H21.6016C22.1536 22.0952 22.6016 22.5432 22.6016 23.0952C22.6016 23.6472 22.1536 24.0952 21.6016 24.0952Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.685 24.0952C15.133 24.0952 14.6796 23.6472 14.6796 23.0952C14.6796 22.5432 15.121 22.0952 15.673 22.0952H15.685C16.237 22.0952 16.685 22.5432 16.685 23.0952C16.685 23.6472 16.237 24.0952 15.685 24.0952Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75587 24.0952C9.20387 24.0952 8.74921 23.6472 8.74921 23.0952C8.74921 22.5432 9.19187 22.0952 9.74387 22.0952H9.75587C10.3079 22.0952 10.7559 22.5432 10.7559 23.0952C10.7559 23.6472 10.3079 24.0952 9.75587 24.0952Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.058 8.2215C20.506 8.2215 20.058 7.7735 20.058 7.2215V2.8335C20.058 2.2815 20.506 1.8335 21.058 1.8335C21.61 1.8335 22.058 2.2815 22.058 2.8335V7.2215C22.058 7.7735 21.61 8.2215 21.058 8.2215Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2871 8.2215C9.73511 8.2215 9.28711 7.7735 9.28711 7.2215V2.8335C9.28711 2.2815 9.73511 1.8335 10.2871 1.8335C10.8391 1.8335 11.2871 2.2815 11.2871 2.8335V7.2215C11.2871 7.7735 10.8391 8.2215 10.2871 8.2215Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_892_11175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 27,
    height: 28
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 3.93896H28.6667V30.5002H2.66669V3.93896Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_892_11175)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.028 5.93896C6.57069 5.93896 4.66669 7.78296 4.66669 11.131V23.1963C4.66669 26.6176 6.57069 28.5003 10.028 28.5003H21.3054C24.7627 28.5003 26.6667 26.6523 26.6667 23.2976V11.131C26.672 9.4843 26.2294 8.2043 25.3507 7.3243C24.4467 6.41763 23.0534 5.93896 21.3174 5.93896H10.028ZM21.3054 30.5003H10.028C5.48802 30.5003 2.66669 27.7016 2.66669 23.1963V11.131C2.66669 6.69363 5.48802 3.93896 10.028 3.93896H21.3174C23.596 3.93896 25.48 4.62163 26.7667 5.91096C28.016 7.16563 28.6734 8.96963 28.6667 11.1336V23.2976C28.6667 27.7403 25.8454 30.5003 21.3054 30.5003Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCalendar);
export default __webpack_public_path__ + "static/media/dashboard-calendar.3864eb4251cdc33d0b6df05ec021c037.svg";
export { ForwardRef as ReactComponent };